// extracted by mini-css-extract-plugin
export default {"settings_notifications":"NotificationSettings_settings_notifications__QqTZx"};